import LiveDashboard from '../components/modules/dashboard/liveDashboard';
import Dashboard from '../components/modules/dashboard/Dashboard';

const dashboard = [
  {
    path: '/dashboard-live',
    name: 'LiveDashboard',
    component: LiveDashboard,
    meta: {
      title: 'Dashboard',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
    },
  },
];

export default dashboard;
